export const transactStatusHeaders = [
    { label:'DATE', key:'date' },
    { label:'OK', key:'ok' },
    { label:'BANK REJECT', key:'bankReject' },
    { label:'FRAUD REJECT', key:'fraudReject' },
    { label:'ERROR', key:'error' },
]


export const appHeader = [
    { label: 'Fecha', key :'date' },
    { label: 'App Hotel Casa de la Playa', key: 'HCDP' },
    { label: 'App hoteles Xcaret', key: 'HOTEL' },
    { label: 'App ferries', key: 'FERRY' },
    { label: 'App Eventos', key: 'EVENTS' },
    { label: 'App Landing', key: 'APPLANDING' },
]

export const transactByWeekHeaders = [
    { label:'L', key:'L', },
    { label:'M', key:'M', },
    { label:'Mi', key:'Mi',},
    { label:'J', key:'J', },
    { label:'V', key:'V', },
    { label:'S', key:'S', },
    { label:'D', key:'D', },
]

export const transactByHourHeader = [
    { label:'00 hrs', key:'00' },
    { label:'01 hrs', key:'01' },
    { label:'02 hrs', key:'02' },
    { label:'03 hrs', key:'03' },
    { label:'04 hrs', key:'04' },
    { label:'05 hrs', key:'05' },
    { label:'06 hrs', key:'06' },
    { label:'07 hrs', key:'07' },
    { label:'08 hrs', key:'08' },
    { label:'09 hrs', key:'09' },
    { label:'10 hrs', key:'10' },
    { label:'11 hrs', key:'11' },
    { label:'12 hrs', key:'12' },
    { label:'13 hrs', key:'13' },
    { label:'14 hrs', key:'14' },
    { label:'15 hrs', key:'15' },
    { label:'16 hrs', key:'16' },
    { label:'17 hrs', key:'17' },
    { label:'18 hrs', key:'18' },
    { label:'19 hrs', key:'19' },
    { label:'20 hrs', key:'20' },
    { label:'21 hrs', key:'21' },
    { label:'22 hrs', key:'22' },
    { label:'23 hrs', key:'23' },
]

export const transactByOSHeader = [
    { label:'OS', key:'os' },
    { label:'TOTAL', key:'cant' },
]

export const transactByServiceHeader = [
    { label:'PARK', key:'PARK'},
    { label:'HOTEL', key:'HOTEL'},
    { label:'FERRY', key:'FERRY'},
    { label:'HCDP', key:'HCDP'},
]

export const totalTransactHeaders = [
    { label:'OK', key:'Ok' },
    { label:'BANK REJECT', key:'Banco' },
    { label:'FRAUD REJECT', key:'Fraude' },
    { label:'ERROR', key:'Error' },
]
